// src/Components/Auth/InlogForm.js
import React from 'react';
import './inlogForm.css';

const InlogForm = ({ email, setEmail, password, setPassword, onLogin, error, setRegisterOpen }) => {
  return (
    <div className="login-container">
      <form onSubmit={onLogin} className="login-form">
        <h2>Welkom,</h2>
        {error && <p className="error-message">{error}</p>}
        <div className="input-group">
          <label htmlFor="email">Email address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <label htmlFor="password">Wachtwoord</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">Login</button>
        {/* <p>
          Wachtwoord vergeten? <a href="/reset">Reset hier</a>
        </p> */}
        <p>
          Heb je geen account? <button type="button" className="link-button" onClick={() => setRegisterOpen(true)}>Registreer hier</button>
        </p>
      </form>
    </div>
  );
};

export default InlogForm;
